<template>
  <div>
    <Icon
      class="close-modal-icon" type="md-close"
      @click="closeModal"
    />
    <Row class="pay-code-box">
      <p class="pay-amount">需付金额：<span class="pay-text">{{ common.formateNumber(payObj.amount || 0) }}</span></p>
      <div class="bg-code-box">
        <div
          id="qrCode" class="code-img"
          style="padding:3px;background:#fff"
        ></div>
        <div v-if="payStatus" class="code-result-metion">
          <Icon
            v-if="payStatus=='S'" class="tips-icon success-icon"
            type="ios-checkmark-circle"
          />
          <Icon
            v-if="payStatus=='F'" class="tips-icon error-icon"
            type="ios-close-circle"
          />
          <Icon
            v-if="payStatus=='TO'" class="tips-icon warning-icon"
            type="ios-stopwatch"
          />
        </div>
        <p>打开微信二维码支付</p>
        <p v-if="payStatus=='S'" class="refresh-code success-icon">支付完成</p>
        <p v-if="payStatus=='F'" class="refresh-code error-icon">支付失败，请重新申请支付</p>
        <p v-if="payStatus=='TO'" class="refresh-code error-icon">已超时，请重新申请支付</p>
      </div>
      <p v-if="payTips" class="pay-tips">温馨提示:{{ payTips }}。</p>
      <p class="count-down">
        <Icon size="16" type="md-alarm" />
        倒计时：<count-down
          v-if="payObj.payLimitTime" class="count-down-text"
          :time="payObj.payLimitTime || 0" @timeOver="payStatus='TO'"
        />
      </p>
    </Row>
  </div>
</template>
<script>
import QRCode from 'qrcodejs2'
export default {
  components: {},
  // payObj 后端返回的二维码相关数组 payTips 提示用于
  props: ['payObj', 'payTips'],
  data () {
    return {
      payStatus: false,
      statusInterval: ''
    }
  },
  watch: {},
  created() {},
  beforeMount() {},
  mounted() {
    this.useQrCode(this.payObj.codeUrl)
    this.getPayStatus(this.payObj.paymentId)
  },
  updated() {},
  methods: {
    // 动态生成二维码
    useQrCode(copyText) {
      this.codeCtrl = true
      const qrcode = new QRCode(document.getElementById('qrCode'), {
        width: 124,
        height: 124,
        text: copyText, // 二维码地址
        colorDark: '#000',
        colorLight: '#fff'
      })
    },
    getPayStatus(id) {
      const t = this
      let countTime = 0
      this.statusInterval = setInterval(() => {
        countTime += 1000
        const url = `/settlement/payment/${id}/result`
        t.$get(url).then(res => {
          if (res.code == 0) {
            if (res.data == 'S' || res.data == 'F') {
              t.payStatus = res.data
              clearInterval(this.statusInterval)
              t.$emit('doneFunc')
            }
          }
        })
        if (countTime == 5 * 60000) {
          clearInterval(this.statusInterval)
          return
        }
      }, 1000)
    },
    closeModal() {
      this.$emit('closeModal', true)
      clearInterval(this.statusInterval)
    }
  }
}
</script>
<style lang="scss" scoped>
@import "./codePay.scss";
.close-icon{
    position: absolute;
    top:0;
    right: 0;
    font-size: 18px;
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/common/codePay/codePay.vue